
/**
 * Encore Foundation - 1.12.0
 * 
 * The contents of this file is owned and generated by the Global Design Systems team.
 * If you require making changes to the values stored here please reach out
 * to #encore on Slack.
 * 
 * Links:
 * 
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 * 
 * Tack!
 * 
 * Global Design Systems
 * encore.spotify.net
 */

var aquamarine = exports.aquamarine = '#9bf0e1';
var aubergine = exports.aubergine = '#503750';
var azure = exports.azure = '#509bf5';
var bole = exports.bole = '#c87d55';
var brightRed = exports.brightRed = '#e61e32';
var chocolate = exports.chocolate = '#7d4b32';
var citric = exports.citric = '#cdf564';
var electricSeafoam = exports.electricSeafoam = '#19e68c';
var factoryYellow = exports.factoryYellow = '#fae62d';
var forest = exports.forest = '#006450';
var fuchsia = exports.fuchsia = '#dc148c';
var gold = exports.gold = '#f59b23';
var kleinBlue = exports.kleinBlue = '#4100f5';
var lavender = exports.lavender = '#b49bc8';
var maroon = exports.maroon = '#8c1932';
var midnight = exports.midnight = '#1e3264';
var neonGreen = exports.neonGreen = '#5ff550';
var orange = exports.orange = '#ff6437';
var pink = exports.pink = '#ffcdd2';
var powderGreen = exports.powderGreen = '#c3f0c8';
var royalBlue = exports.royalBlue = '#2d46b9';
var salmon = exports.salmon = '#f573a0';
var spearmint = exports.spearmint = '#27856a';
var storm = exports.storm = '#a0c3d2';
var sunflower = exports.sunflower = '#ffc864';
var tan = exports.tan = '#c39687';
var tangerine = exports.tangerine = '#e3230e';
var violet = exports.violet = '#af2896';
var success = exports.success = '#1db954';
var announcement = exports.announcement = '#2e77d0';
var info = exports.info = '#eeeeee';
var warning = exports.warning = '#ff5722';
var failure = exports.failure = '#e22134';
var gray7 = exports.gray7 = '#121212';
var gray10 = exports.gray10 = '#181818';
var gray15 = exports.gray15 = '#282828';
var gray20 = exports.gray20 = '#333333';
var gray30 = exports.gray30 = '#535353';
var gray50 = exports.gray50 = '#7f7f7f';
var gray70 = exports.gray70 = '#b3b3b3';
var gray80 = exports.gray80 = '#cccccc';
var gray85 = exports.gray85 = '#d9d9d9';
var gray90 = exports.gray90 = '#eeeeee';
var gray95 = exports.gray95 = '#f8f8f8';
var gray25 = exports.gray25 = '#404040';
var black0 = exports.black0 = 'rgba(0, 0, 0, 0)';
var black10 = exports.black10 = 'rgba(0, 0, 0, 0.1)';
var black30 = exports.black30 = 'rgba(0, 0, 0, 0.3)';
var black50 = exports.black50 = 'rgba(0, 0, 0, 0.5)';
var black60 = exports.black60 = 'rgba(0, 0, 0, 0.6)';
var black70 = exports.black70 = 'rgba(0, 0, 0, 0.7)';
var black90 = exports.black90 = 'rgba(0, 0, 0, 0.9)';
var white0 = exports.white0 = 'rgba(255, 255, 255, 0)';
var white10 = exports.white10 = 'rgba(255, 255, 255, 0.1)';
var white30 = exports.white30 = 'rgba(255, 255, 255, 0.3)';
var white50 = exports.white50 = 'rgba(255, 255, 255, 0.5)';
var white60 = exports.white60 = 'rgba(255, 255, 255, 0.6)';
var white70 = exports.white70 = 'rgba(255, 255, 255, 0.7)';
var white90 = exports.white90 = 'rgba(255, 255, 255, 0.9)';
var black20 = exports.black20 = 'rgba(0, 0, 0, 0.2)';
var black40 = exports.black40 = 'rgba(0, 0, 0, 0.4)';
var white5 = exports.white5 = 'rgba(255, 255, 255, 0.05)';
var white20 = exports.white20 = 'rgba(255, 255, 255, 0.2)';
var white40 = exports.white40 = 'rgba(255, 255, 255, 0.4)';
var green = exports.green = '#1db954';
var greenLight = exports.greenLight = '#1ed760';
var greenFocus = exports.greenFocus = '#1da64d';
var greenDark = exports.greenDark = '#14833b';
var black = exports.black = '#000000';
var white = exports.white = '#ffffff';
var red = exports.red = '#cd1a2b';
var redLight = exports.redLight = '#e22134';
var redDark = exports.redDark = '#941320';
var blue = exports.blue = '#2e77d0';
var blueLight = exports.blueLight = '#4687d6';
var blueFacebook = exports.blueFacebook = '#3a5897';
var blueDark = exports.blueDark = '#1d4c85';
var orangeLight = exports.orangeLight = '#ff5722';
var circularSpotifyUiArabicBlackOtf = exports.circularSpotifyUiArabicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.otf';
var circularSpotifyUiArabicBlackWoff = exports.circularSpotifyUiArabicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff';
var circularSpotifyUiArabicBlackWoff2 = exports.circularSpotifyUiArabicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Black.woff2';
var circularSpotifyUiArabicBoldOtf = exports.circularSpotifyUiArabicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.otf';
var circularSpotifyUiArabicBoldWoff = exports.circularSpotifyUiArabicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff';
var circularSpotifyUiArabicBoldWoff2 = exports.circularSpotifyUiArabicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Bold.woff2';
var circularSpotifyUiArabicBookOtf = exports.circularSpotifyUiArabicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.otf';
var circularSpotifyUiArabicBookWoff = exports.circularSpotifyUiArabicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff';
var circularSpotifyUiArabicBookWoff2 = exports.circularSpotifyUiArabicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Book.woff2';
var circularSpotifyUiArabicLightOtf = exports.circularSpotifyUiArabicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.otf';
var circularSpotifyUiArabicLightWoff = exports.circularSpotifyUiArabicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff';
var circularSpotifyUiArabicLightWoff2 = exports.circularSpotifyUiArabicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Light.woff2';
var circularSpotifyUiArabicMediumOtf = exports.circularSpotifyUiArabicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.otf';
var circularSpotifyUiArabicMediumWoff = exports.circularSpotifyUiArabicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff';
var circularSpotifyUiArabicMediumWoff2 = exports.circularSpotifyUiArabicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Arabic-Medium.woff2';
var circularSpotifyUiCyrillicBlackOtf = exports.circularSpotifyUiCyrillicBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.otf';
var circularSpotifyUiCyrillicBlackWoff = exports.circularSpotifyUiCyrillicBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff';
var circularSpotifyUiCyrillicBlackWoff2 = exports.circularSpotifyUiCyrillicBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Black.woff2';
var circularSpotifyUiCyrillicBoldOtf = exports.circularSpotifyUiCyrillicBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.otf';
var circularSpotifyUiCyrillicBoldWoff = exports.circularSpotifyUiCyrillicBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff';
var circularSpotifyUiCyrillicBoldWoff2 = exports.circularSpotifyUiCyrillicBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Bold.woff2';
var circularSpotifyUiCyrillicBookOtf = exports.circularSpotifyUiCyrillicBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.otf';
var circularSpotifyUiCyrillicBookWoff = exports.circularSpotifyUiCyrillicBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff';
var circularSpotifyUiCyrillicBookWoff2 = exports.circularSpotifyUiCyrillicBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Book.woff2';
var circularSpotifyUiCyrillicLightOtf = exports.circularSpotifyUiCyrillicLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.otf';
var circularSpotifyUiCyrillicLightWoff = exports.circularSpotifyUiCyrillicLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff';
var circularSpotifyUiCyrillicLightWoff2 = exports.circularSpotifyUiCyrillicLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Light.woff2';
var circularSpotifyUiCyrillicMediumOtf = exports.circularSpotifyUiCyrillicMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.otf';
var circularSpotifyUiCyrillicMediumWoff = exports.circularSpotifyUiCyrillicMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff';
var circularSpotifyUiCyrillicMediumWoff2 = exports.circularSpotifyUiCyrillicMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Cyrillic-Medium.woff2';
var circularSpotifyUiHebrewBlackOtf = exports.circularSpotifyUiHebrewBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.otf';
var circularSpotifyUiHebrewBlackWoff = exports.circularSpotifyUiHebrewBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff';
var circularSpotifyUiHebrewBlackWoff2 = exports.circularSpotifyUiHebrewBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Black.woff2';
var circularSpotifyUiHebrewBoldOtf = exports.circularSpotifyUiHebrewBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.otf';
var circularSpotifyUiHebrewBoldWoff = exports.circularSpotifyUiHebrewBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff';
var circularSpotifyUiHebrewBoldWoff2 = exports.circularSpotifyUiHebrewBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Bold.woff2';
var circularSpotifyUiHebrewBookOtf = exports.circularSpotifyUiHebrewBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.otf';
var circularSpotifyUiHebrewBookWoff = exports.circularSpotifyUiHebrewBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff';
var circularSpotifyUiHebrewBookWoff2 = exports.circularSpotifyUiHebrewBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Book.woff2';
var circularSpotifyUiHebrewLightOtf = exports.circularSpotifyUiHebrewLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.otf';
var circularSpotifyUiHebrewLightWoff = exports.circularSpotifyUiHebrewLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff';
var circularSpotifyUiHebrewLightWoff2 = exports.circularSpotifyUiHebrewLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Light.woff2';
var circularSpotifyUiHebrewMediumOtf = exports.circularSpotifyUiHebrewMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.otf';
var circularSpotifyUiHebrewMediumWoff = exports.circularSpotifyUiHebrewMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff';
var circularSpotifyUiHebrewMediumWoff2 = exports.circularSpotifyUiHebrewMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Hebrew-Medium.woff2';
var circularSpotifyUiLatinBlackOtf = exports.circularSpotifyUiLatinBlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.otf';
var circularSpotifyUiLatinBlackWoff = exports.circularSpotifyUiLatinBlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff';
var circularSpotifyUiLatinBlackWoff2 = exports.circularSpotifyUiLatinBlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Black.woff2';
var circularSpotifyUiLatinBoldOtf = exports.circularSpotifyUiLatinBoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.otf';
var circularSpotifyUiLatinBoldWoff = exports.circularSpotifyUiLatinBoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff';
var circularSpotifyUiLatinBoldWoff2 = exports.circularSpotifyUiLatinBoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Bold.woff2';
var circularSpotifyUiLatinBookOtf = exports.circularSpotifyUiLatinBookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.otf';
var circularSpotifyUiLatinBookWoff = exports.circularSpotifyUiLatinBookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff';
var circularSpotifyUiLatinBookWoff2 = exports.circularSpotifyUiLatinBookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Book.woff2';
var circularSpotifyUiLatinLightOtf = exports.circularSpotifyUiLatinLightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.otf';
var circularSpotifyUiLatinLightWoff = exports.circularSpotifyUiLatinLightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff';
var circularSpotifyUiLatinLightWoff2 = exports.circularSpotifyUiLatinLightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Light.woff2';
var circularSpotifyUiLatinMediumOtf = exports.circularSpotifyUiLatinMediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.otf';
var circularSpotifyUiLatinMediumWoff = exports.circularSpotifyUiLatinMediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff';
var circularSpotifyUiLatinMediumWoff2 = exports.circularSpotifyUiLatinMediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-Medium.woff2';
var circularSpotifyUiLatinOs2V3BlackOtf = exports.circularSpotifyUiLatinOs2V3BlackOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.otf';
var circularSpotifyUiLatinOs2V3BlackWoff = exports.circularSpotifyUiLatinOs2V3BlackWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff';
var circularSpotifyUiLatinOs2V3BlackWoff2 = exports.circularSpotifyUiLatinOs2V3BlackWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff2';
var circularSpotifyUiLatinOs2V3BoldOtf = exports.circularSpotifyUiLatinOs2V3BoldOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.otf';
var circularSpotifyUiLatinOs2V3BoldWoff = exports.circularSpotifyUiLatinOs2V3BoldWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff';
var circularSpotifyUiLatinOs2V3BoldWoff2 = exports.circularSpotifyUiLatinOs2V3BoldWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff2';
var circularSpotifyUiLatinOs2V3BookOtf = exports.circularSpotifyUiLatinOs2V3BookOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.otf';
var circularSpotifyUiLatinOs2V3BookWoff = exports.circularSpotifyUiLatinOs2V3BookWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff';
var circularSpotifyUiLatinOs2V3BookWoff2 = exports.circularSpotifyUiLatinOs2V3BookWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff2';
var circularSpotifyUiLatinOs2V3LightOtf = exports.circularSpotifyUiLatinOs2V3LightOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.otf';
var circularSpotifyUiLatinOs2V3LightWoff = exports.circularSpotifyUiLatinOs2V3LightWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff';
var circularSpotifyUiLatinOs2V3LightWoff2 = exports.circularSpotifyUiLatinOs2V3LightWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Light.woff2';
var circularSpotifyUiLatinOs2V3MediumOtf = exports.circularSpotifyUiLatinOs2V3MediumOtf = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.otf';
var circularSpotifyUiLatinOs2V3MediumWoff = exports.circularSpotifyUiLatinOs2V3MediumWoff = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff';
var circularSpotifyUiLatinOs2V3MediumWoff2 = exports.circularSpotifyUiLatinOs2V3MediumWoff2 = 'https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Medium.woff2';
var circularMonoLatinBookOtf = exports.circularMonoLatinBookOtf = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.otf';
var circularMonoLatinBookWoff = exports.circularMonoLatinBookWoff = 'https://encore.scdn.co/1.2.3/Circular-Mono-Latin-Book.woff';
var sieulguilSpotifyLatinHangulBlackOtf = exports.sieulguilSpotifyLatinHangulBlackOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.otf';
var sieulguilSpotifyLatinHangulBlackWoff = exports.sieulguilSpotifyLatinHangulBlackWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff';
var sieulguilSpotifyLatinHangulBlackWoff2 = exports.sieulguilSpotifyLatinHangulBlackWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Black.woff2';
var sieulguilSpotifyLatinHangulBoldOtf = exports.sieulguilSpotifyLatinHangulBoldOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.otf';
var sieulguilSpotifyLatinHangulBoldWoff = exports.sieulguilSpotifyLatinHangulBoldWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff';
var sieulguilSpotifyLatinHangulBoldWoff2 = exports.sieulguilSpotifyLatinHangulBoldWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Bold.woff2';
var sieulguilSpotifyLatinHangulLightOtf = exports.sieulguilSpotifyLatinHangulLightOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.otf';
var sieulguilSpotifyLatinHangulLightWoff = exports.sieulguilSpotifyLatinHangulLightWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff';
var sieulguilSpotifyLatinHangulLightWoff2 = exports.sieulguilSpotifyLatinHangulLightWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Light.woff2';
var sieulguilSpotifyLatinHangulMediumOtf = exports.sieulguilSpotifyLatinHangulMediumOtf = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.otf';
var sieulguilSpotifyLatinHangulMediumWoff = exports.sieulguilSpotifyLatinHangulMediumWoff = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff';
var sieulguilSpotifyLatinHangulMediumWoff2 = exports.sieulguilSpotifyLatinHangulMediumWoff2 = 'https://encore.scdn.co/1.2.3/SieulguilSpotify-Latin-Hangul-Medium.woff2';
var opacity0 = exports.opacity0 = '0';
var opacity10 = exports.opacity10 = '0.1';
var opacity30 = exports.opacity30 = '0.3';
var opacity50 = exports.opacity50 = '0.5';
var opacity70 = exports.opacity70 = '0.7';
var opacity90 = exports.opacity90 = '0.9';
var spacer4 = exports.spacer4 = '4px';
var spacer8 = exports.spacer8 = '8px';
var spacer12 = exports.spacer12 = '12px';
var spacer16 = exports.spacer16 = '16px';
var spacer20 = exports.spacer20 = '20px';
var spacer24 = exports.spacer24 = '24px';
var spacer32 = exports.spacer32 = '32px';
var spacer40 = exports.spacer40 = '40px';
var spacer48 = exports.spacer48 = '48px';
var spacer56 = exports.spacer56 = '56px';
var spacer64 = exports.spacer64 = '64px';
var spacer72 = exports.spacer72 = '72px';
var spacer80 = exports.spacer80 = '80px';
var balladFontSize = exports.balladFontSize = '16px';
var balladLineHeight = exports.balladLineHeight = '24px';
var balladWeight = exports.balladWeight = 400;
var balladFont = exports.balladFont = 'Circular';
var balladUppercase = exports.balladUppercase = 'none';
var balladTracking = exports.balladTracking = 'normal';
var balladBoldFontSize = exports.balladBoldFontSize = '16px';
var balladBoldLineHeight = exports.balladBoldLineHeight = '24px';
var balladBoldWeight = exports.balladBoldWeight = 700;
var balladBoldFont = exports.balladBoldFont = 'Circular';
var balladBoldUppercase = exports.balladBoldUppercase = 'none';
var balladBoldTracking = exports.balladBoldTracking = 'normal';
var violaFontSize = exports.violaFontSize = '14px';
var violaLineHeight = exports.violaLineHeight = '20px';
var violaWeight = exports.violaWeight = 400;
var violaFont = exports.violaFont = 'Circular';
var violaUppercase = exports.violaUppercase = 'none';
var violaTracking = exports.violaTracking = 'normal';
var violaBoldFontSize = exports.violaBoldFontSize = '14px';
var violaBoldLineHeight = exports.violaBoldLineHeight = '20px';
var violaBoldWeight = exports.violaBoldWeight = 700;
var violaBoldFont = exports.violaBoldFont = 'Circular';
var violaBoldUppercase = exports.violaBoldUppercase = 'none';
var violaBoldTracking = exports.violaBoldTracking = 'normal';
var mestoFontSize = exports.mestoFontSize = '14px';
var mestoLineHeight = exports.mestoLineHeight = '16px';
var mestoWeight = exports.mestoWeight = 400;
var mestoFont = exports.mestoFont = 'Circular';
var mestoUppercase = exports.mestoUppercase = 'none';
var mestoTracking = exports.mestoTracking = 'normal';
var mestoBoldFontSize = exports.mestoBoldFontSize = '14px';
var mestoBoldLineHeight = exports.mestoBoldLineHeight = '16px';
var mestoBoldWeight = exports.mestoBoldWeight = 700;
var mestoBoldFont = exports.mestoBoldFont = 'Circular';
var mestoBoldUppercase = exports.mestoBoldUppercase = 'none';
var mestoBoldTracking = exports.mestoBoldTracking = 'normal';
var bassFontSize = exports.bassFontSize = '96px';
var bassFontSizeMedium = exports.bassFontSizeMedium = '72px';
var bassFontSizeSmall = exports.bassFontSizeSmall = '48px';
var bassLineHeight = exports.bassLineHeight = '96px';
var bassLineHeightMedium = exports.bassLineHeightMedium = '72px';
var bassLineHeightSmall = exports.bassLineHeightSmall = '48px';
var bassTracking = exports.bassTracking = '-0.04em';
var bassWeight = exports.bassWeight = 900;
var bassFont = exports.bassFont = 'Circular';
var bassUppercase = exports.bassUppercase = 'none';
var forteFontSize = exports.forteFontSize = '72px';
var forteLineHeight = exports.forteLineHeight = '72px';
var forteTracking = exports.forteTracking = '-0.04em';
var forteWeight = exports.forteWeight = 900;
var forteFont = exports.forteFont = 'Circular';
var forteUppercase = exports.forteUppercase = 'none';
var brioFontSize = exports.brioFontSize = '48px';
var brioLineHeight = exports.brioLineHeight = '48px';
var brioTracking = exports.brioTracking = '-0.04em';
var brioWeight = exports.brioWeight = 700;
var brioFont = exports.brioFont = 'Circular';
var brioUppercase = exports.brioUppercase = 'none';
var metronomeFontSize = exports.metronomeFontSize = '14px';
var metronomeLineHeight = exports.metronomeLineHeight = '16px';
var metronomeTracking = exports.metronomeTracking = '0.1em';
var metronomeWeight = exports.metronomeWeight = 700;
var metronomeFont = exports.metronomeFont = 'Circular';
var metronomeUppercase = exports.metronomeUppercase = 'uppercase';
var minuetFontSize = exports.minuetFontSize = '12px';
var minuetLineHeight = exports.minuetLineHeight = '16px';
var minuetTracking = exports.minuetTracking = '0.1em';
var minuetWeight = exports.minuetWeight = 400;
var minuetFont = exports.minuetFont = 'Circular';
var minuetUppercase = exports.minuetUppercase = 'uppercase';
var minuetBoldFontSize = exports.minuetBoldFontSize = '12px';
var minuetBoldLineHeight = exports.minuetBoldLineHeight = '16px';
var minuetBoldTracking = exports.minuetBoldTracking = '0.1em';
var minuetBoldWeight = exports.minuetBoldWeight = 700;
var minuetBoldFont = exports.minuetBoldFont = 'Circular';
var minuetBoldUppercase = exports.minuetBoldUppercase = 'uppercase';
var finaleFontSize = exports.finaleFontSize = '11px';
var finaleLineHeight = exports.finaleLineHeight = '16px';
var finaleWeight = exports.finaleWeight = 400;
var finaleFont = exports.finaleFont = 'Circular';
var finaleUppercase = exports.finaleUppercase = 'none';
var finaleTracking = exports.finaleTracking = 'normal';
var finaleBoldFontSize = exports.finaleBoldFontSize = '11px';
var finaleBoldLineHeight = exports.finaleBoldLineHeight = '16px';
var finaleBoldWeight = exports.finaleBoldWeight = 700;
var finaleBoldFont = exports.finaleBoldFont = 'Circular';
var finaleBoldUppercase = exports.finaleBoldUppercase = 'none';
var finaleBoldTracking = exports.finaleBoldTracking = 'normal';
var altoFontSize = exports.altoFontSize = '32px';
var altoLineHeight = exports.altoLineHeight = '36px';
var altoTracking = exports.altoTracking = '-0.04em';
var altoWeight = exports.altoWeight = 700;
var altoFont = exports.altoFont = 'Circular';
var altoUppercase = exports.altoUppercase = 'none';
var canonFontSize = exports.canonFontSize = '24px';
var canonLineHeight = exports.canonLineHeight = '28px';
var canonTracking = exports.canonTracking = '-0.04em';
var canonWeight = exports.canonWeight = 700;
var canonFont = exports.canonFont = 'Circular';
var canonUppercase = exports.canonUppercase = 'none';
var celloFontSize = exports.celloFontSize = '18px';
var celloLineHeight = exports.celloLineHeight = '24px';
var celloWeight = exports.celloWeight = 700;
var celloFont = exports.celloFont = 'Circular';
var celloUppercase = exports.celloUppercase = 'none';
var celloTracking = exports.celloTracking = 'normal';
var color = exports.color = {
          aquamarine: aquamarine,
aubergine: aubergine,
azure: azure,
bole: bole,
brightRed: brightRed,
chocolate: chocolate,
citric: citric,
electricSeafoam: electricSeafoam,
factoryYellow: factoryYellow,
forest: forest,
fuchsia: fuchsia,
gold: gold,
kleinBlue: kleinBlue,
lavender: lavender,
maroon: maroon,
midnight: midnight,
neonGreen: neonGreen,
orange: orange,
pink: pink,
powderGreen: powderGreen,
royalBlue: royalBlue,
salmon: salmon,
spearmint: spearmint,
storm: storm,
sunflower: sunflower,
tan: tan,
tangerine: tangerine,
violet: violet,
success: success,
announcement: announcement,
info: info,
warning: warning,
failure: failure,
gray7: gray7,
gray10: gray10,
gray15: gray15,
gray20: gray20,
gray30: gray30,
gray50: gray50,
gray70: gray70,
gray80: gray80,
gray85: gray85,
gray90: gray90,
gray95: gray95,
gray25: gray25,
black0: black0,
black10: black10,
black30: black30,
black50: black50,
black60: black60,
black70: black70,
black90: black90,
white0: white0,
white10: white10,
white30: white30,
white50: white50,
white60: white60,
white70: white70,
white90: white90,
black20: black20,
black40: black40,
white5: white5,
white20: white20,
white40: white40,
green: green,
greenLight: greenLight,
greenFocus: greenFocus,
greenDark: greenDark,
black: black,
white: white,
red: red,
redLight: redLight,
redDark: redDark,
blue: blue,
blueLight: blueLight,
blueFacebook: blueFacebook,
blueDark: blueDark,
orangeLight: orangeLight,
        };
var cdn = exports.cdn = {
          circularSpotifyUiArabicBlackOtf: circularSpotifyUiArabicBlackOtf,
circularSpotifyUiArabicBlackWoff: circularSpotifyUiArabicBlackWoff,
circularSpotifyUiArabicBlackWoff2: circularSpotifyUiArabicBlackWoff2,
circularSpotifyUiArabicBoldOtf: circularSpotifyUiArabicBoldOtf,
circularSpotifyUiArabicBoldWoff: circularSpotifyUiArabicBoldWoff,
circularSpotifyUiArabicBoldWoff2: circularSpotifyUiArabicBoldWoff2,
circularSpotifyUiArabicBookOtf: circularSpotifyUiArabicBookOtf,
circularSpotifyUiArabicBookWoff: circularSpotifyUiArabicBookWoff,
circularSpotifyUiArabicBookWoff2: circularSpotifyUiArabicBookWoff2,
circularSpotifyUiArabicLightOtf: circularSpotifyUiArabicLightOtf,
circularSpotifyUiArabicLightWoff: circularSpotifyUiArabicLightWoff,
circularSpotifyUiArabicLightWoff2: circularSpotifyUiArabicLightWoff2,
circularSpotifyUiArabicMediumOtf: circularSpotifyUiArabicMediumOtf,
circularSpotifyUiArabicMediumWoff: circularSpotifyUiArabicMediumWoff,
circularSpotifyUiArabicMediumWoff2: circularSpotifyUiArabicMediumWoff2,
circularSpotifyUiCyrillicBlackOtf: circularSpotifyUiCyrillicBlackOtf,
circularSpotifyUiCyrillicBlackWoff: circularSpotifyUiCyrillicBlackWoff,
circularSpotifyUiCyrillicBlackWoff2: circularSpotifyUiCyrillicBlackWoff2,
circularSpotifyUiCyrillicBoldOtf: circularSpotifyUiCyrillicBoldOtf,
circularSpotifyUiCyrillicBoldWoff: circularSpotifyUiCyrillicBoldWoff,
circularSpotifyUiCyrillicBoldWoff2: circularSpotifyUiCyrillicBoldWoff2,
circularSpotifyUiCyrillicBookOtf: circularSpotifyUiCyrillicBookOtf,
circularSpotifyUiCyrillicBookWoff: circularSpotifyUiCyrillicBookWoff,
circularSpotifyUiCyrillicBookWoff2: circularSpotifyUiCyrillicBookWoff2,
circularSpotifyUiCyrillicLightOtf: circularSpotifyUiCyrillicLightOtf,
circularSpotifyUiCyrillicLightWoff: circularSpotifyUiCyrillicLightWoff,
circularSpotifyUiCyrillicLightWoff2: circularSpotifyUiCyrillicLightWoff2,
circularSpotifyUiCyrillicMediumOtf: circularSpotifyUiCyrillicMediumOtf,
circularSpotifyUiCyrillicMediumWoff: circularSpotifyUiCyrillicMediumWoff,
circularSpotifyUiCyrillicMediumWoff2: circularSpotifyUiCyrillicMediumWoff2,
circularSpotifyUiHebrewBlackOtf: circularSpotifyUiHebrewBlackOtf,
circularSpotifyUiHebrewBlackWoff: circularSpotifyUiHebrewBlackWoff,
circularSpotifyUiHebrewBlackWoff2: circularSpotifyUiHebrewBlackWoff2,
circularSpotifyUiHebrewBoldOtf: circularSpotifyUiHebrewBoldOtf,
circularSpotifyUiHebrewBoldWoff: circularSpotifyUiHebrewBoldWoff,
circularSpotifyUiHebrewBoldWoff2: circularSpotifyUiHebrewBoldWoff2,
circularSpotifyUiHebrewBookOtf: circularSpotifyUiHebrewBookOtf,
circularSpotifyUiHebrewBookWoff: circularSpotifyUiHebrewBookWoff,
circularSpotifyUiHebrewBookWoff2: circularSpotifyUiHebrewBookWoff2,
circularSpotifyUiHebrewLightOtf: circularSpotifyUiHebrewLightOtf,
circularSpotifyUiHebrewLightWoff: circularSpotifyUiHebrewLightWoff,
circularSpotifyUiHebrewLightWoff2: circularSpotifyUiHebrewLightWoff2,
circularSpotifyUiHebrewMediumOtf: circularSpotifyUiHebrewMediumOtf,
circularSpotifyUiHebrewMediumWoff: circularSpotifyUiHebrewMediumWoff,
circularSpotifyUiHebrewMediumWoff2: circularSpotifyUiHebrewMediumWoff2,
circularSpotifyUiLatinBlackOtf: circularSpotifyUiLatinBlackOtf,
circularSpotifyUiLatinBlackWoff: circularSpotifyUiLatinBlackWoff,
circularSpotifyUiLatinBlackWoff2: circularSpotifyUiLatinBlackWoff2,
circularSpotifyUiLatinBoldOtf: circularSpotifyUiLatinBoldOtf,
circularSpotifyUiLatinBoldWoff: circularSpotifyUiLatinBoldWoff,
circularSpotifyUiLatinBoldWoff2: circularSpotifyUiLatinBoldWoff2,
circularSpotifyUiLatinBookOtf: circularSpotifyUiLatinBookOtf,
circularSpotifyUiLatinBookWoff: circularSpotifyUiLatinBookWoff,
circularSpotifyUiLatinBookWoff2: circularSpotifyUiLatinBookWoff2,
circularSpotifyUiLatinLightOtf: circularSpotifyUiLatinLightOtf,
circularSpotifyUiLatinLightWoff: circularSpotifyUiLatinLightWoff,
circularSpotifyUiLatinLightWoff2: circularSpotifyUiLatinLightWoff2,
circularSpotifyUiLatinMediumOtf: circularSpotifyUiLatinMediumOtf,
circularSpotifyUiLatinMediumWoff: circularSpotifyUiLatinMediumWoff,
circularSpotifyUiLatinMediumWoff2: circularSpotifyUiLatinMediumWoff2,
circularSpotifyUiLatinOs2V3BlackOtf: circularSpotifyUiLatinOs2V3BlackOtf,
circularSpotifyUiLatinOs2V3BlackWoff: circularSpotifyUiLatinOs2V3BlackWoff,
circularSpotifyUiLatinOs2V3BlackWoff2: circularSpotifyUiLatinOs2V3BlackWoff2,
circularSpotifyUiLatinOs2V3BoldOtf: circularSpotifyUiLatinOs2V3BoldOtf,
circularSpotifyUiLatinOs2V3BoldWoff: circularSpotifyUiLatinOs2V3BoldWoff,
circularSpotifyUiLatinOs2V3BoldWoff2: circularSpotifyUiLatinOs2V3BoldWoff2,
circularSpotifyUiLatinOs2V3BookOtf: circularSpotifyUiLatinOs2V3BookOtf,
circularSpotifyUiLatinOs2V3BookWoff: circularSpotifyUiLatinOs2V3BookWoff,
circularSpotifyUiLatinOs2V3BookWoff2: circularSpotifyUiLatinOs2V3BookWoff2,
circularSpotifyUiLatinOs2V3LightOtf: circularSpotifyUiLatinOs2V3LightOtf,
circularSpotifyUiLatinOs2V3LightWoff: circularSpotifyUiLatinOs2V3LightWoff,
circularSpotifyUiLatinOs2V3LightWoff2: circularSpotifyUiLatinOs2V3LightWoff2,
circularSpotifyUiLatinOs2V3MediumOtf: circularSpotifyUiLatinOs2V3MediumOtf,
circularSpotifyUiLatinOs2V3MediumWoff: circularSpotifyUiLatinOs2V3MediumWoff,
circularSpotifyUiLatinOs2V3MediumWoff2: circularSpotifyUiLatinOs2V3MediumWoff2,
circularMonoLatinBookOtf: circularMonoLatinBookOtf,
circularMonoLatinBookWoff: circularMonoLatinBookWoff,
sieulguilSpotifyLatinHangulBlackOtf: sieulguilSpotifyLatinHangulBlackOtf,
sieulguilSpotifyLatinHangulBlackWoff: sieulguilSpotifyLatinHangulBlackWoff,
sieulguilSpotifyLatinHangulBlackWoff2: sieulguilSpotifyLatinHangulBlackWoff2,
sieulguilSpotifyLatinHangulBoldOtf: sieulguilSpotifyLatinHangulBoldOtf,
sieulguilSpotifyLatinHangulBoldWoff: sieulguilSpotifyLatinHangulBoldWoff,
sieulguilSpotifyLatinHangulBoldWoff2: sieulguilSpotifyLatinHangulBoldWoff2,
sieulguilSpotifyLatinHangulLightOtf: sieulguilSpotifyLatinHangulLightOtf,
sieulguilSpotifyLatinHangulLightWoff: sieulguilSpotifyLatinHangulLightWoff,
sieulguilSpotifyLatinHangulLightWoff2: sieulguilSpotifyLatinHangulLightWoff2,
sieulguilSpotifyLatinHangulMediumOtf: sieulguilSpotifyLatinHangulMediumOtf,
sieulguilSpotifyLatinHangulMediumWoff: sieulguilSpotifyLatinHangulMediumWoff,
sieulguilSpotifyLatinHangulMediumWoff2: sieulguilSpotifyLatinHangulMediumWoff2,
        };
var opacity = exports.opacity = {
          opacity0: opacity0,
opacity10: opacity10,
opacity30: opacity30,
opacity50: opacity50,
opacity70: opacity70,
opacity90: opacity90,
        };
var spacer = exports.spacer = {
          spacer4: spacer4,
spacer8: spacer8,
spacer12: spacer12,
spacer16: spacer16,
spacer20: spacer20,
spacer24: spacer24,
spacer32: spacer32,
spacer40: spacer40,
spacer48: spacer48,
spacer56: spacer56,
spacer64: spacer64,
spacer72: spacer72,
spacer80: spacer80,
        };
var type = exports.type = {
          balladFontSize: balladFontSize,
balladLineHeight: balladLineHeight,
balladWeight: balladWeight,
balladFont: balladFont,
balladUppercase: balladUppercase,
balladTracking: balladTracking,
balladBoldFontSize: balladBoldFontSize,
balladBoldLineHeight: balladBoldLineHeight,
balladBoldWeight: balladBoldWeight,
balladBoldFont: balladBoldFont,
balladBoldUppercase: balladBoldUppercase,
balladBoldTracking: balladBoldTracking,
violaFontSize: violaFontSize,
violaLineHeight: violaLineHeight,
violaWeight: violaWeight,
violaFont: violaFont,
violaUppercase: violaUppercase,
violaTracking: violaTracking,
violaBoldFontSize: violaBoldFontSize,
violaBoldLineHeight: violaBoldLineHeight,
violaBoldWeight: violaBoldWeight,
violaBoldFont: violaBoldFont,
violaBoldUppercase: violaBoldUppercase,
violaBoldTracking: violaBoldTracking,
mestoFontSize: mestoFontSize,
mestoLineHeight: mestoLineHeight,
mestoWeight: mestoWeight,
mestoFont: mestoFont,
mestoUppercase: mestoUppercase,
mestoTracking: mestoTracking,
mestoBoldFontSize: mestoBoldFontSize,
mestoBoldLineHeight: mestoBoldLineHeight,
mestoBoldWeight: mestoBoldWeight,
mestoBoldFont: mestoBoldFont,
mestoBoldUppercase: mestoBoldUppercase,
mestoBoldTracking: mestoBoldTracking,
bassFontSize: bassFontSize,
bassFontSizeMedium: bassFontSizeMedium,
bassFontSizeSmall: bassFontSizeSmall,
bassLineHeight: bassLineHeight,
bassLineHeightMedium: bassLineHeightMedium,
bassLineHeightSmall: bassLineHeightSmall,
bassTracking: bassTracking,
bassWeight: bassWeight,
bassFont: bassFont,
bassUppercase: bassUppercase,
forteFontSize: forteFontSize,
forteLineHeight: forteLineHeight,
forteTracking: forteTracking,
forteWeight: forteWeight,
forteFont: forteFont,
forteUppercase: forteUppercase,
brioFontSize: brioFontSize,
brioLineHeight: brioLineHeight,
brioTracking: brioTracking,
brioWeight: brioWeight,
brioFont: brioFont,
brioUppercase: brioUppercase,
metronomeFontSize: metronomeFontSize,
metronomeLineHeight: metronomeLineHeight,
metronomeTracking: metronomeTracking,
metronomeWeight: metronomeWeight,
metronomeFont: metronomeFont,
metronomeUppercase: metronomeUppercase,
minuetFontSize: minuetFontSize,
minuetLineHeight: minuetLineHeight,
minuetTracking: minuetTracking,
minuetWeight: minuetWeight,
minuetFont: minuetFont,
minuetUppercase: minuetUppercase,
minuetBoldFontSize: minuetBoldFontSize,
minuetBoldLineHeight: minuetBoldLineHeight,
minuetBoldTracking: minuetBoldTracking,
minuetBoldWeight: minuetBoldWeight,
minuetBoldFont: minuetBoldFont,
minuetBoldUppercase: minuetBoldUppercase,
finaleFontSize: finaleFontSize,
finaleLineHeight: finaleLineHeight,
finaleWeight: finaleWeight,
finaleFont: finaleFont,
finaleUppercase: finaleUppercase,
finaleTracking: finaleTracking,
finaleBoldFontSize: finaleBoldFontSize,
finaleBoldLineHeight: finaleBoldLineHeight,
finaleBoldWeight: finaleBoldWeight,
finaleBoldFont: finaleBoldFont,
finaleBoldUppercase: finaleBoldUppercase,
finaleBoldTracking: finaleBoldTracking,
altoFontSize: altoFontSize,
altoLineHeight: altoLineHeight,
altoTracking: altoTracking,
altoWeight: altoWeight,
altoFont: altoFont,
altoUppercase: altoUppercase,
canonFontSize: canonFontSize,
canonLineHeight: canonLineHeight,
canonTracking: canonTracking,
canonWeight: canonWeight,
canonFont: canonFont,
canonUppercase: canonUppercase,
celloFontSize: celloFontSize,
celloLineHeight: celloLineHeight,
celloWeight: celloWeight,
celloFont: celloFont,
celloUppercase: celloUppercase,
celloTracking: celloTracking,
        };